import * as Yup from "yup";

export const equipmentSchema = Yup.object().shape({
  // note 설비정보 1
  installLocation: Yup.string().required("설치위치를 입력하세요."), // 설치위치
  personName: Yup.string().required("설비책임자를 입력하세요."), //설비책임자
  type: Yup.number(), // 설비분류
  identifyNumber: Yup.string().required("설비번호를 입력하세요."), // 설비번호
  name: Yup.string().required("설비명을 입력하세요."), // 설비명
  manufacture: Yup.string(), // 제작사
  modelNo: Yup.string(), // 모델
  serialNo: Yup.string(), // 시리얼넘버
  price: Yup.number(), // 금액
  eqLevel: Yup.string().required("설비등급을 입력하세요."), // 설비등급

  // note 신뢰성
  hasReliability: Yup.boolean(), // 신뢰성 확인
  lifeTime: Yup.number(), // 설비수명
  daysOfWork: Yup.number(), // 0 - 연 매일 24시간, 1~7 - 주 1~7일
  workHoursForDay: Yup.number(), //일 가동일
  isPSM: Yup.boolean(), // PSM유무

  // note 설비정보 2
  capacity: Yup.string(), // 용량
  law: Yup.string(), // 법적대상
  checkTermMonth: Yup.string(), // 점검주기 - 월단위
  nextDate: Yup.date(), // 점검기준일
  installDate: Yup.date(), // 설치일자
  wideLevel: Yup.string(), // 방폭등급
  drivePressure: Yup.string(), // 운전(압략)
  designPressure: Yup.string(), // 설계(압력)
  pressure1Unit: Yup.number(), // 압력단위
  pressure2Unit: Yup.number(), // 압력단위
  driveTemperature: Yup.string(), //운전(온도)
  designTemperature: Yup.string(), //설계(온도)

  // note 첨부파일
  processDocumentBase64: Yup.string(),
  certificationBase64: Yup.string(),
  pAndIDBase64: Yup.string(),
  pictureBase64: Yup.string(),
  // pictureBase64: Yup.mixed().test(
  //   "required",
  //   "please select image",
  //   (value) => value && value.length
  // ), // base64 이미지파일

  // note not used
  // uid: Yup.string(),
  // companyUid: Yup.number(),
  // departmentUID: Yup.number(),
  // //Attachments
  // processDocument: Yup.string(),
  // certification: Yup.string(),
  // pAndID: Yup.string(),
  // picture: Yup.string(),
  // email: Yup.string(),
  // entryDate: Yup.date(),
  // modifyDate: Yup.date(),
  // creatorUID: Yup.number(), // 작성자 UID - Import한 사람도 해당됨
  // officerUID: Yup.number(), // 할당된 담당자 UID
});
